import { useTranslations } from "use-intl";
import { BaseResolver, BaseResolverProps } from "./BaseResolver";
export const CollaboratorsResolver = (props: Omit<BaseResolverProps, "type">) => {
  const t = useTranslations();
  return <BaseResolver {...props} type="collaboratorResolver" useReferenceOptions isMulti placeholder={"Collaborators"} data-sentry-element="BaseResolver" data-sentry-component="CollaboratorsResolver" data-sentry-source-file="CollaboratorsResolver.tsx" />;
};